import { render, staticRenderFns } from "./noticePage.vue?vue&type=template&id=526b2f57&scoped=true"
import script from "./noticePage.vue?vue&type=script&lang=js"
export * from "./noticePage.vue?vue&type=script&lang=js"
import style0 from "./noticePage.vue?vue&type=style&index=0&id=526b2f57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b2f57",
  null
  
)

export default component.exports